import numeral from 'numeral';

//学校统计
export const xxtjColumns = [
    {
        title: '序号',
        width: '60px',
        dataIndex: 'row_id',
        fixed: 'left'
    }, {
        title: '学生类别',
        width: '120px',
        dataIndex: 'XSLB',
        key: 'xslb',
        sorted: false,
        commonSearch: false,
        search: 'input'
    },{
        title: '环节名称',
        width: '120px',
        dataIndex: 'HJMC',
        key: 'hjmc',
        sorted: false,
        commonSearch: false
    },{
        title: '总人数',
        width: '80px',
        dataIndex: 'ZRS',
        key: 'zrs',
        commonSearch: false
    }, {
        title: '未办理',
        width: '80px',
        dataIndex: 'WTBZRS',
        key: 'wtbzrs',
        commonSearch: false
    }, {
        title: '已办理',
        width: '80px',
        dataIndex: 'YTBZRS',
        key: 'ytbzrs',
        commonSearch: false
    }, {
        title: '办理率',
        width: '80px',
        dataIndex: 'TBL',
        commonSearch: false,
        render: (value) => {
            return numeral(value * 100).format("0.00") + '%';
        }
    }
];

//学院统计
export const xytjColumns = [
    {
        title: '序号',
        width: '60px',
        dataIndex: 'row_id',
        fixed: 'left'
    }, {
        title: '学院名称',
        width: '120px',
        dataIndex: 'BMMC',
        key: 'bmmc',
        commonSearch: false,
        search: 'input'
    }, {
        title: '学生类别',
        width: '120px',
        dataIndex: 'XSLB',
        key: 'xslb',
        sorted: false,
        commonSearch: false,
        search: 'input'
    },{
        title: '环节名称',
        width: '120px',
        dataIndex: 'HJMC',
        key: 'hjmc',
        sorted: false,
        commonSearch: false
    }, {
        title: '总人数',
        width: '80px',
        dataIndex: 'ZRS',
        key: 'zrs',
        commonSearch: false
    }, {
        title: '未办理',
        width: '80px',
        dataIndex: 'WTBZRS',
        key: 'wtbzrs',
        commonSearch: false
    }, {
        title: '已办理',
        width: '80px',
        dataIndex: 'YTBZRS',
        key: 'ytbzrs',
        commonSearch: false
    }, {
        title: '办理率',
        width: '80px',
        dataIndex: 'TBL',
        commonSearch: false,
        render: (value) => {
            return numeral(value * 100).format("0.00") + '%';
        }
    }
];

//专业统计
export const zytjColumns = [
    {
        title: '序号',
        width: '60px',
        dataIndex: 'row_id',
        fixed: 'left'
    },{
        title: '学院名称',
        width: '120px',
        dataIndex: 'BMMC',
        key: 'bmmc',
        commonSearch: false,
        search: 'input',
        sorted: false,
        // render: (text, record,index) => {
        //     const obj = {
        //         children: record.BMMC,
        //         props: {},
        //       };
        //       if (record.BZ==1) {
        //         obj.props.rowSpan = record.BMS;
        //       }else if(index==0 && record.BZ !== 1){
        //         obj.props.rowSpan = record.BMS - record.BZ + 1;
        //       }
        //       else {
        //         obj.props.rowSpan = 0;
        //       }
        //       return obj;
        // }
    },{
        title: '专业名称',
        width: '120px',
        dataIndex: 'ZYMC',
        key: 'zymc',
        commonSearch: false,
        search: 'input',
        sorted: false,
    }, {
        title: '学生类别',
        width: '120px',
        dataIndex: 'XSLB',
        key: 'xslb',
        sorted: false,
        search: 'input',
        commonSearch: false,
    },{
        title: '环节名称',
        width: '120px',
        dataIndex: 'HJMC',
        key: 'hjmc',
        sorted: false,
        commonSearch: false
    }, {
        title: '总人数',
        width: '80px',
        dataIndex: 'ZRS',
        key: 'zrs',
        sorted: true,
        commonSearch: false
    }, {
        title: '未办理',
        width: '80px',
        dataIndex: 'WTBZRS',
        key: 'wtbzrs',
        sorted: true,
        commonSearch: false
    }, {
        title: '已办理',
        width: '80px',
        dataIndex: 'YTBZRS',
        key: 'ytbzrs',
        sorted: true,
        commonSearch: false
    }, {
        title: '办理率',
        width: '80px',
        dataIndex: 'TBL',
        sorted: true,
        commonSearch: false,
        render: (value) => {
            return numeral(value * 100).format("0.00") + '%';
        }
    }
];

//省内外统计
export const snwtjColumns = [
    {
        title: '序号',
        width: '60px',
        dataIndex: 'row_id',
        fixed: 'left'
    }, {
        title: '学生类别',
        width: '140px',
        dataIndex: 'XSLB',
        fixed: 'left',
        key: 'xslb',
        sorted: false,
        commonSearch: false,
        search: 'input'
    },{
        title: '环节名称',
        width: '140px',
        dataIndex: 'HJMC',
        fixed: 'left',
        key: 'hjmc',
        sorted: false,
        commonSearch: false
    }, {
        title: '省内总人数',
        width: '110px',
        dataIndex: 'SNZRS',
        key: 'snzrs',
        commonSearch: false
    }, {
        title: '省内已办理',
        width: '110px',
        dataIndex: 'SNYTBZRS',
        key: 'snytbzrs',
        commonSearch: false
    }, {
        title: '省内未办理',
        width: '110px',
        dataIndex: 'SNWTBZRS',
        key: 'snwtbzrs',
        commonSearch: false
    }, {
        title: '省内办理率',
        width: '110px',
        dataIndex: 'SNTBL',
        commonSearch: false,
        render: (value) => {
            return numeral(value * 100).format("0.00") + '%';
        }
    }, {
        title: '省外总人数',
        width: '110px',
        dataIndex: 'SWZRS',
        key: 'swzrs',
        commonSearch: false
    }, {
        title: '省外已办理',
        width: '110px',
        dataIndex: 'SWYTBZRS',
        key: 'swytbzrs',
        commonSearch: false
    }, {
        title: '省外未办理',
        width: '110px',
        dataIndex: 'SWWTBZRS',
        key: 'swwtbzrs',
        commonSearch: false
    }, {
        title: '省外办理率',
        width: '110px',
        dataIndex: 'SWTBL',
        commonSearch: false,
        render: (value) => {
            return numeral(value * 100).format("0.00") + '%';
        }
    }, {
        title: '其他总人数(无生源地)',
        width: '170px',
        dataIndex: 'WSYDZRS',
        key: 'wsydzrs',
        commonSearch: false
    }, {
        title: '其他已办理(无生源地)',
        width: '170px',
        dataIndex: 'WSYDYTBZRS',
        key: 'wsydytbzrs',
        commonSearch: false
    }, {
        title: '其他未办理(无生源地)',
        width: '170px',
        dataIndex: 'WSYDWTBZRS',
        key: 'wsydwtbzrs',
        commonSearch: false
    }, {
        title: '其他办理率(无生源地)',
        width: '170px',
        dataIndex: 'WSYDTBL',
        commonSearch: false,
        render: (value) => {
            return numeral(value * 100).format("0.00") + '%';
        }
    }
];


// WEBPACK FOOTER //
// ./components/tjcx/zzbdtjcx/jxZzbdtjcx/constant.js